import { render, staticRenderFns } from "./WebServerSetupChecks.vue?vue&type=template&id=47ce094c&scoped=true"
import script from "./WebServerSetupChecks.vue?vue&type=script&lang=js"
export * from "./WebServerSetupChecks.vue?vue&type=script&lang=js"
import style0 from "./WebServerSetupChecks.vue?vue&type=style&index=0&id=47ce094c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ce094c",
  null
  
)

export default component.exports